import {
	FETCH_FLOW_ADMIN_RCA_REPORTS_INIT,
 	FETCH_FLOW_ADMIN_RCA_REPORTS_SUCCESS,
 	FETCH_FLOW_ADMIN_RCA_REPORTS_FAILURE,
	RESET_FLOW_ADMIN_RCA_REPORTS,
  	SET_FILTER_FLOW_ADMIN_RCA_REPORTS
 } from './types';
 import API from './api';

export function setFilterFlowAdminRcaReports(obj) {
  return {
    type: SET_FILTER_FLOW_ADMIN_RCA_REPORTS,
    payload: obj
  };
}

export function resetFlowAdminRcaReports() {
  return {
    type: RESET_FLOW_ADMIN_RCA_REPORTS,
  };
}


 function fetchApiSuccess(data) {
 	return {
 		type: FETCH_FLOW_ADMIN_RCA_REPORTS_SUCCESS,
 		payload: data,
 	};
 }

 function fetchApiFailure(error) {
 	console.log(error)
 	return {
 		type: FETCH_FLOW_ADMIN_RCA_REPORTS_FAILURE,
 		payload: error,
 	};
 }

 function fetchApiInit() {
 	return {
 		type: FETCH_FLOW_ADMIN_RCA_REPORTS_INIT,
 	};
 }

 export function fetchFlowAdminRcaReportsApi(filters) {
 	return async (dispatch) => {
 		dispatch(fetchApiInit());
 		try {
 			let data = await API.data.getAll(filters);
 			dispatch(fetchApiSuccess(data));
 		} catch (error) {
 			dispatch(fetchApiFailure(error));
 		}
 	};
 }

 export function downloadExcelStats(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadExcelStats(filter);
    } catch (error) {}
  };
}

export function downloadExcelCharts(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadExcelCharts(filter);
    } catch (error) {}
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/flow_admin_rca_reports/index.js